





































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Company from "../../../store/entities/company";
import aMap from './amap.vue'
@Component({
  components: { aMap },
})
export default class EditCompany extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  aMapModalShow:boolean=false;
  editmap:string="editmap";
  created() {}
  company: Company = new Company();
  openAmap(){
    this.aMapModalShow=true;
  }
  mapaddr(longitude,latitude){
//console.log(longitude+latitude);
    this.company["longitude"] = longitude;
    this.company["latitude"] = latitude;
  }
   typelist=[
                {
                    value: 0,
                    label: '温湿度'
                },
                {
                    value: 1,
                    label: '烟虫'
                },
                {
                    value: 2,
                    label: '水分'
                },
                {
                    value: 3,
                    label: '温湿度加烟虫'
                },
                {
                    value: 4,
                    label: '温湿度加水分'
                }
            ]
  save() {
    (this.$refs.companyForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "company/update",
          data: this.company,
        });
        (this.$refs.companyForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.companyForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.company = Util.extend(true, {}, this.$store.state.company.editCompany);
    }
  }
  companyRule = {
    cName: [{ required: true, message: "请填写企业名称", trigger: "blur" }],
    addr: [{ required: true, message: "请填写企业地址", trigger: "blur" }],
    cPhone: [{ required: true, message: "请填写企业电话", trigger: "blur" }],
    linkName: [{ required: true, message: "请填写联系人", trigger: "blur" }],
    linkMobile: [{ required: true, message: "请填写联系人电话", trigger: "blur" }],
    type: [{type: "number",required: true,message: "请选择安装的设备",trigger: "change"}],
  };
}
